import { gql } from "@apollo/client";

export default gql`
  mutation unsubmitAssessment($assessmentIds: [Int!]!) {
    reopenAssessment(assessmentIds: $assessmentIds) {
      assessments {
        id
        state
        assessmentDeliveryState
        assessmentDelivery {
          id
          state
        }
      }
    }
  }
`;
